import { render, staticRenderFns } from "./CmgPageNotFound.vue?vue&type=template&id=2432a71d&scoped=true&lang=pug&"
import script from "./cmg-page-not-found.ts?vue&type=script&lang=ts&"
export * from "./cmg-page-not-found.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPageNotFound.vue?vue&type=style&index=0&id=2432a71d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432a71d",
  null
  
)

export default component.exports